import React, { FC, ReactElement, ReactNode } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { TranslationKey, useTranslation } from '../translations';
import { useForm } from '../utils';

interface ActionButtonProps {
  readonly id: string;
  readonly title: TranslationKey | ReactElement;
  readonly children: ReactNode;
  // Button inside of the modal
  readonly actionContent: TranslationKey;
  readonly isOpen: boolean;

  readonly color: 'danger' | 'primary' | 'secondary' | 'success' | 'info';

  readonly close: () => void;
  readonly onComplete: () => Promise<void>;
}

export const ActionModal: FC<ActionButtonProps> = ({
  id,
  title,
  children,
  actionContent,
  isOpen,
  color,
  close,
  onComplete,
}) => {
  const { ts } = useTranslation();
  const form = useForm(async () => {
    await onComplete();
    close();
  }, [onComplete, close]);

  return (
    <Modal id={`${id}Modal`} isOpen={isOpen || form.saving} toggle={close}>
      <form onSubmit={form.onSubmit}>
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        <ModalHeader>{React.isValidElement<any>(title) ? title : ts(title)}</ModalHeader>
        <ModalBody>{children}</ModalBody>
        <ModalFooter>
          <Button color={color} disabled={form.saving} id="complete" type="submit">
            {ts(actionContent)}
          </Button>{' '}
          <Button color="secondary" disabled={form.saving} id="cancel" onClick={close} outline>
            {ts('common.cancel')}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
